var _rect, _ellipse, _path, _ellipse2, _ellipse3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupsDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 88,
    viewBox: "0 0 81 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 88,
    rx: 32,
    fill: "#4880FF",
    fillOpacity: 0.35
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.0002,
    cy: 37,
    rx: 7,
    ry: 8,
    fill: "#4880FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0002 56C54.0002 60.4183 48.1799 59 41.0002 59C33.8205 59 28.0002 60.4183 28.0002 56C28.0002 51.5817 33.8205 46 41.0002 46C48.1799 46 54.0002 51.5817 54.0002 56Z",
    fill: "#4880FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5002,
    cy: 36,
    rx: 5.5,
    ry: 6,
    fill: "#4880FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.5002,
    cy: 36,
    rx: 5.5,
    ry: 6,
    fill: "#4880FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2559 46.1207C66.4179 49.371 65.365 52.4536 60.6846 54.1269C56.0041 55.8002 56.5308 52.9058 55.3687 49.6555C54.2067 46.4052 47.0878 45.7131 51.7683 44.0398C56.4487 42.3665 64.0939 42.8704 65.2559 46.1207Z",
    fill: "#4880FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 46.1207C14.8579 49.371 15.9109 52.4536 20.5913 54.1269C25.2717 55.8002 24.7451 52.9058 25.9071 49.6555C27.0692 46.4052 34.188 45.7131 29.5076 44.0398C24.8272 42.3665 17.182 42.8704 16.02 46.1207Z",
    fill: "#4880FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsDashboard);
export default __webpack_public_path__ + "static/media/groups-dashboard.c72693c76a76d07d0acbfa5d2fa2e70d.svg";
export { ForwardRef as ReactComponent };